import { call, put } from 'redux-saga/effects'
import AuthActions from 'Redux/AuthRedux'
import VideoActions from 'Redux/VideoRedux'
import SelectionActions from 'Redux/SelectionRedux'
import { pick } from 'ramda'
import { authDataKeys } from 'Services/Api'
import { BuildErrorMsg } from './ApiHelpers'
import ApiErrorMessages from './ApiErrorMessages'

export function * onProfileRequest (api, action) {
  const resp = yield call(api.me)
  if (resp.ok) {
    yield put(AuthActions.profileSuccess(resp.data))
  } else {
    yield put(
      AuthActions.profileFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onSignupRequest (api, action) {
  const resp = yield call(
    api.signup, action.email, action.password, action.teamName
  )
  if (resp.ok) {
    yield put(AuthActions.signupSuccess(
      {message: 'Please check you mail for confirmation link'}))
  } else {
    yield put(
      AuthActions.signupFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onForgotPasswordRequest (api, action) {
  const resp = yield call(api.forgotPassword, action.email)
  if (resp.ok) {
    yield put(AuthActions.forgotPasswordSuccess(resp.data))
  } else {
    yield put(
      AuthActions.forgotPasswordFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onResetPasswordRequest (api, action) {
  const resp = yield call(api.resetPassword, action.params, action.headers)
  if (resp.ok) {
    const authData = pick(authDataKeys, resp.headers)
    yield call(api.setAuthData, authData)
    yield put(AuthActions.loginSuccess(
      authData, resp.data.data, action.redirectTo))
  } else {
    yield put(AuthActions.resetPasswordFailure(BuildErrorMsg(resp)))
  }
}

export function * onLoginRequest (api, action) {
  const resp = yield call(
    api.login, action.email, action.password
  )
  if (resp.ok) {
    const authData = pick(authDataKeys, resp.headers)
    yield call(api.setAuthData, authData)
    yield put(AuthActions.loginSuccess(authData, resp.data.data))
  } else {
    yield put(AuthActions.loginFailure(BuildErrorMsg(resp)))
  }
}

export function * onGoogleLoginRequest (api, action) {
  const resp = yield call(
    api.googleLogin, action.authData
  )
  if (resp.ok) {
    const authData = pick(authDataKeys, resp.headers)
    yield call(api.setAuthData, authData)
    yield put(AuthActions.loginSuccess(authData, resp.data))
  } else {
    yield put(AuthActions.loginFailure(BuildErrorMsg(resp)))
  }
}

export function * onLogoutRequest (api, action) {
  yield put(AuthActions.logoutSuccess())
  yield call(api.deleteAuthData)
  yield call(api.logout)
  yield put(SelectionActions.selectionsSetData('activeTeams', {}))
  yield put(SelectionActions.selectionsSetData('activeProject', {}))
  yield put(VideoActions.videosListSuccess([]))
}

export function * onUserConfirmationSuccess (api, action) {
  yield call(api.setAuthData, action.authData)
  const resp = yield call(api.me)
  if (resp.ok) {
    yield put(AuthActions.loginSuccess(action.authData, resp.data))
  } else {
    yield put(AuthActions.loginFailure(BuildErrorMsg(resp)))
  }
}

export function * onProfileUpdateRequest (api, action) {
  const resp = yield call(api.updateProfile, action.updateParams)
  if (resp.ok) {
    yield put(AuthActions.profileUpdateSuccess(resp.data.data))
    yield put(AuthActions.profileRequest())
  } else if (ApiErrorMessages[resp.problem]) {
    yield put(
      AuthActions.profileUpdateFailure(ApiErrorMessages[resp.problem])
    )
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/AuthSagas.js